import { IPermissionSetGrouping, PermissionSetGroupingKey } from '../PermissionSetTypes'
import { PermissionType } from '../PermissionType'

export enum TimeRulePermissionSet {
  View = 'time_rule_view',
  New = 'time_rule_new',
  Edit = 'time_rule_edit',
  Delete = 'time_rule_delete',
}

// Ignore prettier to ensure only one permission per line
// prettier-ignore
export const timeRulePermissionSetGrouping: IPermissionSetGrouping<TimeRulePermissionSet> = {
  key: PermissionSetGroupingKey.TimeRule,
  active: {
    [TimeRulePermissionSet.View]: [
      PermissionType.GET_ANY_TIME_RULE,
      PermissionType.LIST_ANY_TIME_RULE,
    ],
    [TimeRulePermissionSet.New]: [
      PermissionType.POST_ANY_TIME_RULE,
    ],
    [TimeRulePermissionSet.Edit]: [
      PermissionType.PATCH_ANY_TIME_RULE,
    ],
    [TimeRulePermissionSet.Delete]: [
      PermissionType.DELETE_ANY_TIME_RULE,
    ],
  },
  unAssignablePermissionSets: [],
}
